export const TEXT_TYPE = "text";
export const RATING_TYPE = "rating";
